module.exports = __webpack_public_path__ + "img/societario.21014608.svg";